import { render, staticRenderFns } from "./category-filter.vue?vue&type=template&id=4d7a1f34&"
import script from "./category-filter.vue.ts?vue&type=script&lang=ts&"
export * from "./category-filter.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports